<header-row
   [userName]="'Victoria Brown'"
   [userRole]="'REGIONAL MANAGER'"></header-row>
<div class="page-layout">
   <h2 class="main-title">Hospital Goals</h2>
   <div class="stats-grid">
      <div
         class="stat-card"
         *ngFor="let count of goalCounts">
         <div
            class="icon-circle"
            [ngClass]="count.color">
            <span class="material-icons">{{ count.icon }}</span>
         </div>
         <div class="stat-info">
            <div class="count">{{ count.count }}</div>
            <div class="label">{{ count.label }}</div>
         </div>
      </div>
   </div>
   <div class="content-box">
      <div class="box-header">
         <div class="sideheader">
            <h3>Goals Summary</h3>
         </div>
         <div class="filters">
            <div>
               <button
                  class="reset-btn"
                  type="button"
                  (click)="toggleGroupedView()">
                  <span class="material-icons">{{ isGroupedView ? "table_rows" : "view_list" }}</span>
                  {{ isGroupedView ? "Show Flat Table" : "Group by Hospital" }}
               </button>
            </div>
            <div class="select-wrap">
               <p-dropdown
                  [options]="quarterList"
                  [(ngModel)]="selectedQuarter"
                  optionLabel="quarterName"
                  placeholder="Select Qtr"
                  (onChange)="applyQtr()"
                  [showClear]="true"
                  [filter]="true"></p-dropdown>
            </div>
            <div class="select-wrap">
               <p-multiSelect
                  [options]="hospitalList"
                  [(ngModel)]="selectedHospitals"
                  optionLabel="practiceName"
                  placeholder="Filter by Hospital"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} hospitals selected"
                  appendTo="body"></p-multiSelect>
            </div>
            <div class="select-wrap" *ngIf="!isRmRole">
               <p-multiSelect
                  [options]="regionalManagerList"
                  [(ngModel)]="selectedRegionalManagers"
                  placeholder="Filter by Regional Manager"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} RMs selected"
                  appendTo="body"></p-multiSelect>
            </div>
            <div class="select-wrap">
               <p-multiSelect
                  [options]="goalStatus"
                  [(ngModel)]="selectedStatuses"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Filter by Status"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} statuses selected"
                  appendTo="body"></p-multiSelect>
            </div>

            <div class="select-wrap">
               <p-multiSelect
                  [options]="goalDictionaryData"
                  [(ngModel)]="selectedGoals"
                  optionLabel="name"
                  optionValue="name"
                  placeholder="Filter by Goal"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} goals selected"
                  appendTo="body"></p-multiSelect>
            </div>
            <div class="select-wrap">
               <p-multiSelect
                  [options]="leadershipFilterOptions"
                  [(ngModel)]="selectedLeadershipAttentionFlags"
                  optionLabel="label"
                  optionValue="key"
                  placeholder="Filter by Leadership Attention"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} selected"
                  appendTo="body"></p-multiSelect>
            </div>
            <div>
               <button
                  class="reset-btn"
                  type="button"
                  [class.active]="priorityPracticeOnly"
                  (click)="togglePriorityPracticeFilter()">
                  <span class="material-icons">{{ priorityPracticeOnly ? "star" : "star_border" }}</span>
                  Priority Practice
               </button>
            </div>
            <div>
               <button
                  class="reset-btn"
                  (click)="resetFilters()">
                  <span class="material-icons">refresh</span>
                  Reset Filters
               </button>
            </div>
            <button
               class="submit-btn"
               (click)="openAssignModal()">
               <span class="material-icons">add</span>
               Assign New Goal
            </button>
         </div>
      </div>
      <ng-container *ngIf="dataSource?.data?.length > 0; else nogoal">
         <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z1 data-table"
            matSort
            matSortDisableClear
            (matSortChange)="paginator?.firstPage()">
            <!-- Group Header Row -->
            <ng-container matColumnDef="groupHeader">
               <td
                  mat-cell
                  *matCellDef="let row"
                  [attr.colspan]="displayedColumns.length"
                  class="group-cell">
                  <div class="group-header">
                     <button
                        class="group-toggle"
                        type="button"
                        (click)="toggleGroup(row)">
                        <span class="material-icons">{{ isGroupCollapsed(row) ? "add" : "remove" }}</span>
                     </button>
                     <span class="group-title">{{ row.hospitalName }}</span>
                  </div>
               </td>
            </ng-container>

            <!-- Hospital Column -->
            <ng-container matColumnDef="hospitalName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Hospital
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="hospital-col">
                  <span *ngIf="!isGroupedView">{{ row.hospitalName }}</span>
               </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Status
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <span
                     class="status-badge"
                     [ngClass]="getStatusClass(row.status)">
                     {{ getStatusLabel(row.status) }}
                  </span>
               </td>
            </ng-container>

            <ng-container matColumnDef="waitingOn">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Waiting On
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  {{ getWaitingOnLabel(row.waitingOn) }}
               </td>
            </ng-container>

            <!-- Goal Column -->
            <ng-container matColumnDef="goalName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Goal
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.goalName }}
               </td>
            </ng-container>

            <!-- Description Column -->
            <!-- <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef style="width:22%">Goal Description</th>
            <td mat-cell *matCellDef="let row" class="desc-col"
               style="max-width: 260px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; cursor: pointer;"
               (click)="showDescriptionDialog(row.description)">
               <span title="Click to view full description">{{ row.description }}</span>
            </td>
         </ng-container> -->

            <!-- PrimeNG Dialog for full description -->
            <p-dialog
               header="Goal Description"
               [(visible)]="descriptionDialogVisible"
               [modal]="true"
               [style]="{ width: '500px' }"
               [closable]="true"
               (onHide)="descriptionDialogVisible = false">
               <div style="white-space: pre-line; word-break: break-word">
                  {{ descriptionDialogText }}
               </div>
            </p-dialog>

            <!-- Date Column -->
            <ng-container matColumnDef="startDate">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Start Date
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.startDate | date: "MM/dd/yyyy" }}
               </td>
            </ng-container>

            <!-- Days Column -->
            <ng-container matColumnDef="days">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  Days in Status
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <span [ngClass]="getDaysSeverityClass(row.days, row.status)">{{ row.days }}</span>
               </td>
            </ng-container>

            <!-- Tasks Column -->
            <ng-container matColumnDef="tasks">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="padding-left: 16px">
                  Tasks
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <div
                     *ngIf="row.taskInfos[0]?.taskId"
                     class="task-summary"
                     (click)="openViewTask(row.taskInfos)">
                     <span class="material-icons">visibility</span>
                     <div class="task-summary-text">
                        <div class="task-summary-line">
                           <span class="task-summary-count">{{ getCompleteCount(row.taskInfos) }}</span>
                           Complete
                        </div>
                        <div class="task-summary-line">
                           <span class="task-summary-count">{{ getTotalCount(row.taskInfos) }}</span>
                           Total
                        </div>
                     </div>
                  </div>
                  <div
                     *ngIf="!row.taskInfos[0]?.taskId"
                     class="task-summary no-task"
                     (click)="openCreateTask(row)">
                     <span class="material-icons">visibility_off</span>
                     <div class="task-summary-text">
                        <div class="task-summary-line">No tasks</div>
                        <div class="task-summary-line">assigned</div>
                     </div>
                  </div>
               </td>
            </ng-container>
            <!-- Action Column -->
            <ng-container matColumnDef="action">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="padding-left: 16px">
                  Action
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <button
                     *ngIf="row.status === 'PENDING_RM_REVIEW' && row.isCanUserActOn"
                     class="action-pill"
                     (click)="updateStatus(row)">
                     <span class="material-icons">check_circle</span>
                     Action
                  </button>
                  <button
                     *ngIf="row.status === 'PENDING_VP_REVIEW' && row.isCanUserActOn"
                     class="action-pill"
                     (click)="updateStatus(row)">
                     <span class="material-icons">check_circle</span>
                     Action
                  </button>

                  <button
                     *ngIf="!row.isCanUserActOn"
                     class="view-hospital-pill"
                     (click)="updateStatus(row)">
                     <span class="material-icons">visibility</span>
                     View
                  </button>
               </td>
            </ng-container>
            <div
               *ngIf="dataSource?.data?.length === 0"
               style="padding: 20px; text-align: center; color: #999">
               <p>No goalList to display</p>
            </div>
            <tr
               mat-header-row
               *matHeaderRowDef="displayedColumns"></tr>
            <tr
               mat-row
               *matRowDef="let row; columns: ['groupHeader']; when: isGroupRow"
               class="group-row"></tr>
            <tr
               mat-row
               *matRowDef="let row; columns: displayedColumns"
               class="data-row"
               [class.row-hidden]="isRowHidden(row)"
               [attr.id]="'search-row-goal-' + row.goalTargetId"></tr>
         </table>
         <mat-paginator
            [pageSize]="50"
            [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 2000, 5000, 100000]"
            showFirstLastButtons
            aria-label="Select page of periodic elements"></mat-paginator>
      </ng-container>
      <ng-template #nogoal>
         <div
            *ngIf="!isLoading && hasLoadedGoals"
            class="empty-state"
            style="text-align: center; padding: 40px 20px; color: #4f4f4f">
            <div
               class="empty-icon"
               style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 72px;
                  height: 72px;
                  border-radius: 50%;
                  background: #f1f5f9;
                  margin-bottom: 16px;
               ">
               <span
                  class="material-icons"
                  style="color: #00ba9d; font-size: 36px">
                  assignment
               </span>
            </div>
            <h4 style="margin: 0 0 8px; font-weight: 600">No Goal found</h4>
            <p style="margin: 0 0 16px">Try adjusting filters or create a new goal.</p>
         </div>
      </ng-template>
   </div>
</div>

<p-dialog
   header="Goal Description"
   [(visible)]="descriptionDialogVisible"
   [modal]="true"
   [style]="{ width: '500px' }"
   [closable]="true"
   (onHide)="descriptionDialogVisible = false">
   <div style="white-space: pre-line; word-break: break-word">
      {{ descriptionDialogText }}
   </div>
</p-dialog>

<div
   *ngIf="isLoading"
   style="
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.95);
      z-index: 9999;
   ">
   <div style="text-align: center">
      <img
         src="/assets/catSpinner.gif"
         style="width: 130px; margin-bottom: 20px" />
      <div style="color: #363636; font-size: 24px">Please wait...</div>
   </div>
</div>
